export { default as TargetStrategies } from './TargetStrategies';
